import styled from 'styled-components';
import { lightTheme } from '../../themes';
export const Container = styled.div`
  width: 662px;
  margin: 0 auto;
  padding: 30px 0;
  max-width: 100%;
  text-align: left;
`;
export const StepContainer = styled.div``;
export const Title = styled.div`
  font-family: 'AvenirNext-DemiBold';
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.36px;
  color: #3b3b3b;
  margin-top: 30px;
  margin-bottom: 15px;
  text-align: left;
  &:before {
    content: "";
    display: block;
    width: 47px;
    height: 5px;
    background-color: #4a4a4a;
    margin-bottom: 12px;
  }
`;
export const SubTitle = styled.div`
  font-family: 'AvenirNext-Medium';
  font-size: 17px;
  font-weight: 500;
  letter-spacing: 0.49px;
  color: #4a4a4a;
  text-align: left;
`;
export const Process = styled.div`
  position: relative;
  height: 41px;
  margin: 50px 0 100px;
`;
export const Processer = styled.div`
  margin: 0 -60px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const ProcessLine = styled.div`
  width: 100%;
  height: 7px;
  background: #d8d8d8;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  margin: auto 0 auto 20px;
  &.active {
    background: #887fff;
  }
  &.pre-fill {
    background: #d8d8d8;
  }
  &.success {
    background: #76c520;
  }
`;
export const ProcesserItem = styled.div`
  width: 100%;
  text-align: center;
  position: relative;
`;
export const ProcessBar = styled.div`
  width: 31px;
  height: 31px;
  margin: 0 20px 15px;
  display: inline-block;
  background: #FFF;
  border-radius: 50%;
  border: 5px solid #cccccc;
  position: relative;
  cursor: pointer;
  z-index: 1;
  &:before {
    content: "";
    width: 15px;
    height: 7px;
    border-bottom: solid 4.3px #ffffff;
    border-left: solid 4.3px #ffffff;
    display: inline-block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transform: rotate(-45deg);
    margin: auto;
  }
  &.active {
    border-color: #393060;
  }
  &.pre-fill {
    border-color: #76c520;
  }
  &.success {
    background: #76c520;
    border-color: #76c520;
  }
`;
export const ProcessStatus = styled.div`
  font-family: 'AvenirNext-DemiBold';
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #bebfc0;
  width: 80px;
  margin: 0 auto;
  &.active {
    color: #393060;
  }
  &.pre-fill {}
  &.success {
    color: #76c520;
  }
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  &.nomar {
    margin-bottom: 0;
  }
`;
export const Col = styled.div`
  flex: 1;
  padding: 0 10px;
`;
export const InputShipment = styled.div`
  flex: 1;
`;
export const Panel = styled.div`
  margin-bottom: 15px;
`;
export const PanelTitle = styled.div`
  padding: 10px 30px;
  background: ${lightTheme.palette.primary.light};
  text-shadow: 0 2px 4px rgba(0,0,0,0.19);
  font-family: 'AvenirNext-DemiBold';
  font-size: 16px;
  font-weight: 600;
  color: #f4f3ff;
  border-radius: 3px 3px 0 0;
  text-align: left;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
export const PanelContent = styled.div`
  padding: 20px 20px;
  background: #FFF;
  border-radius: 0 0 3px 3px;
  box-shadow: 0 2px 4px 0 rgba(204, 204, 204, 0.42);
  border: solid 1px #e4e4e4;
`;
export const Label = styled.div`
  text-align: left;
  font-family: 'AvenirNext-Medium';
  font-size: 15px;
  font-weight: 500;
  color: ${props => props.isError ? '#d0021b' : '#4a4a4a'};
  margin-bottom: 10px;
  &.right {
    text-align: right;
  }
`;
export const Label_1 = styled.div`
  font-family: 'AvenirNext-Medium';
  font-size: 11px;
  font-weight: 500;
  color: #8d8d8d;
  margin-right: 10px;
`;
export const Label_2 = styled.div`
  font-family: 'AvenirNext-DemiBold';
  font-size: 12.5px;
  font-weight: 600;
  color: #4a4a4a;
  text-align: center;
  margin-bottom: 10px;
`;
export const I = styled.i`
  font-family: 'AvenirNext-MediumItalic';
  font-size: 11px;
  color: #9b9b9b;
  color: ${props => props.isError ? '#d0021b' : '#9b9b9b'};
`;
export const B = styled.b`
  font-family: 'AvenirNext-DemiBold';
  font-size: 12px;
  color: #848484;
`;
export const InputGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0 10px;
  margin-bottom: 15px;
`;
export const InputGroupTitle = styled(InputGroup)`
  margin-bottom: 0;
`;
export const InputItem = styled.div`
  width: 25%;
  padding: 0 5px;
`;
export const InputItemInline = styled.div`
  display: flex;
  align-items: center;
  margin: 0 5px;
`;
export const InputGroupContainer = styled.div`
  border: solid 1px ${lightTheme.palette.primary.light};
  padding: 15px 5px;
  margin-bottom: 15px;
  position: relative;
`;
export const InputGroupInline = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px;
`;
export const CheckboxGroup = styled.div`
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 10px;
`;
export const CheckboxItem = styled.div`
  margin-right: 10px;
  &.nth-last-child(1) {
    margin-right: 0;
  }
`;
export const AddMore = styled.div`
  font-family: 'AvenirNext-DemiBold';
  font-size: 12px;
  font-weight: 600;
  color: #4a4a4a;
`;
export const DescriptionBox = styled.div`
  padding: 15px 25px;
  opacity: 0.6;
  border-radius: 10px;
  background-color: #f4f3ff;
  margin-bottom: 15px;
`;
export const Text = styled.div`
  font-family: 'AvenirNext';
  font-size: 13px;
  color: #848484;
  margin-bottom: 5px;
  text-align: left;
`;
export const Text_1 = styled(Text)`
  font-family: 'AvenirNext-Medium';
  font-size: 12px;
  font-weight: 500;
  color: #aeaeae;
`;
export const Text_2 = styled(Text)`
  font-size: 16px;
  line-height: 25px;
`;
export const Text_3 = styled(Text)`
  font-family: AvenirNext;
  font-size: 14px;
  color: #000;
  margin: 0;
`;
export const Text_4 = styled.span`
  font-family: 'AvenirNext-DemiBoldItalic';
  font-size: 10px;
  font-weight: 600;
  font-style: italic;
  color: ${props => props.isError ? '#d0021b' : lightTheme.palette.primary.main};
`;
export const DeliveryWindowContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;
export const DeliveryWindow = styled.div`
  width: 50%;
  float: left;
  text-align: left;
  margin-bottom: 10px;
`;
export const AddDeliveryWindowContainer = styled.div`
  text-align: left;
`;
export const ButtonEdit = styled.button`
  float: right;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19);
  border: solid 1px #ffffff;
  background-color: rgba(255, 255, 255, 0.15);
  padding: 5px 17px;
  font-family: "AvenirNext-Medium";
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.19);
  font-size: 14px;
  font-weight: 500;
  color: #f4f3ff;
  cursor: pointer;
`;
export const Remove = styled.span`
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
`;
export const RemoveIcon = styled.span`
  position: relative;
  display: inline-block;
  width: 17px;
  height: 17px;
  &:after {
    content: "";
    display: inline-block;
    width: 17px;
    border-top: 1px solid #CCC;
    transform: rotate(45deg);
    position: absolute;
    top: 7px;
  }
  &:before {
    content: "";
    display: inline-block;
    width: 17px;
    border-top: 1px solid #CCC;
    transform: rotate(-45deg);
    position: absolute;
    top: 7px;
  }
`;
export const I1 = styled.i`
  color: ${lightTheme.palette.primary.main};
  margin-right: 5px;
`;
export const I2 = styled.i`
  color: #e26070;
  margin-right: 5px;
`;

export const ErrorText = styled(I)`
  color: red;
  display: inline-block;
  margin-left: 10px;
  vertical-align: 3px;
`;

export const DateTime = styled.div`
  position: relative;
`;
export const TimeText = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 10px;
  z-index: 1;
`;
export const DeliveryWindowShift = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;
export const DeliveryWindowShiftContainer = styled.div`
  border: solid 1px ${lightTheme.palette.primary.light};
  padding: 20px 10px 0px;
`;
export const DeliveryWindowMain = styled.div`
  margin-bottom: 5px;
`;

export default {
  row: {
    marginBottom: 20
  },
  row_1: {
    marginBottom: 35
  },
  row_2: {
    clear: 'both'
  },
  row_3: {
    clear: 'both',
    marginTop: 15
  },
  col: {
    padding: '0 10px'
  },
  col_1: {
    textAlign: 'left'
  },
  col_2: {
    textAlign: 'right'
  },
  col_mid: {
    textAlign: 'center'
  },
  input: {
    background: '#f9f9f9',
    width: '100%'
  },
  input_1: {
    background: '#f9f9f9',
    width: '100%'
  },
  input_2: {
    background: '#f9f9f9',
    width: '100%',
    marginBottom: 10
  },
  input_3: {
    background: '#f9f9f9',
    width: 'auto'
  },
  input_4: {
    height: 22,
    width: 31
  },
  textarea: {
    background: '#f9f9f9',
    width: '100%',
    minHeight: 120,
    resize: 'vertical'
  },
  control: {
    minWidth: 88
  },
  control_1: {
    height: 44,
    minWidth: 188
  },
  controls: {
    justifyContent: 'flex-end'
  },
  add: {
    marginRight: 5
  },
  remove: {
    color: "#ff6666",
  },
  select: {
    width: '100%',
    background: '#f9f9f9',
    borderRadius: 3,
    height: 42
  },
  select_1: {
    width: '100%',
    background: '#f9f9f9',
    borderRadius: 3,
    height: 42,
    marginBottom: 10
  },
  select_2: {
    minWidth: 102,
    height: 22,
    fontSize: 11,
    outline: 'none'
  },
  button_1: {
    borderRadius: 3,
    backgroundColor: 'rgb(190, 198, 216)',
    border: 'none',
    color: '#fff',
    padding: '3px 15px',
    height: 22,
    fontFamily: 'AvenirNext-Medium',
    fontSize: 10,
    fontWeight: 500,
    cursor: 'pointer'
  },
  error: {
    padding: '0 15px 5px',
    textAlign: 'center',
    color: '#ff0000',
  },
  moneyInput: {
    background: '#f9f9f9',
    height: 39,
    fontSize: 17,
    lineHeight: 36,
    border: '1px solid #ccc',
    boxSizing: 'border-box',
    borderRadius: 3,
    padding: '4 14 4 8',
    outline: 'none'
  },
}
